module.exports = __webpack_public_path__ + "img/link_file.23c3450e.png";